/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'project-contributors-picker.done': 'Hotovo',
  'project-contributors-picker.go-back-label': 'Přejít zpět',
  'project-contributors-picker.header': 'Vyberte členy v projektu',
  'project-contributors-picker.your-teams-secondary-text':
    '{membersCount, plural, one {{membersCount,number} člen} few {{membersCount,number} členové} many {{membersCount,number} člena} other {{membersCount,number} členů}}',
  'project-contributors-picker.your-teams-secondary-text-focused':
    '{membersCount, plural, one {Výběr z {membersCount,number} člena} few {Výběr ze {membersCount,number} členů} many {Výběr z {membersCount,number} člena} other {Výběr z {membersCount,number} členů}}',
  'project-contributors-picker.your-teams-title': 'Vaše týmy',
  'project-fields.common.generic-error.description': 'Zkontrolujte připojení k internetu a zkuste to znovu.',
  'project-fields.common.generic-error.title': 'Něco se pokazilo',
  'project-fields.link-item.delete-label': 'Odstranit',
  'project-fields.link-item.edit-label': 'Upravit',
  'project-fields.project-contributes-to.add-goal-title': 'Přidat cíl',
  'project-fields.project-contributes-to.empty-title': 'Žádné cíle',
  'project-fields.project-contributes-to.title': 'Přispívá k:',
  'project-fields.project-contributors.add-contributors-title': 'Přidat přispěvatele',
  'project-fields.project-contributors.empty-title': 'Žádní přispěvatelé',
  'project-fields.project-contributors.remove-contributor': 'Odebrat přispěvatele',
  'project-fields.project-contributors.remove-contributor-error-message': 'Odebrání přispěvatele se nezdařilo',
  'project-fields.project-contributors.remove-team': 'Odebrat tým',
  'project-fields.project-contributors.show-more': 'Zobrazit více',
  'project-fields.project-contributors.title': 'Přispěvatelé',
  'project-fields.project-contributors.view-profile': 'Zobrazit profil',
  'project-fields.project-contributors.view-profile-team': 'Zobrazit profil',
  'project-fields.project-focus-areas.title': 'Oblasti zaměření',
  'project-fields.project-followers.add-followers-title': 'Přidat sledující',
  'project-fields.project-followers.empty-title': 'Žádní sledující',
  'project-fields.project-followers.title': 'Sledující',
  'project-fields.project-link-picker.aria-label': 'Naposledy zobrazené odkazy',
  'project-fields.project-link-picker.invalid-link-input.error':
    'Zkontrolujte, zda odkaz obsahuje platnou adresou URL.',
  'project-fields.project-link-picker.link-input.clear-label': 'Vymazat odkaz',
  'project-fields.project-link-picker.link-input.placeholder': 'Vložit odkaz nebo vyhledat nedávno zobrazené',
  'project-fields.project-link-picker.text-input.clear-label': 'Vymazat text',
  'project-fields.project-link-picker.text-input.placeholder': 'Text k zobrazení (volitelné)',
  'project-fields.project-links.add-links-title': 'Přidat odkazy',
  'project-fields.project-links.add-links-tooltip': 'Přidat odkazy na dokumenty, designy a další',
  'project-fields.project-links.delete-link-button': 'Odstranit odkaz',
  'project-fields.project-links.edit-link-button': 'Upravit odkaz',
  'project-fields.project-links.empty-title': 'Žádné odkazy',
  'project-fields.project-links.title': 'Odkazy',
  'project-fields.project-owner.title': 'Vlastník',
  'project-fields.project-start-date.add-start-date-title': 'Přidat datum zahájení',
  'project-fields.project-start-date.cancel-button': 'Uložit',
  'project-fields.project-start-date.creation-date': 'Projekt byl vytvořen dne {creationDate}.',
  'project-fields.project-start-date.edit-start-date-label': 'Upravit datum zahájení projektu',
  'project-fields.project-start-date.empty-title': 'Žádné datum zahájení',
  'project-fields.project-start-date.enter-start-date-title': 'Zadejte datum zahájení',
  'project-fields.project-start-date.open-calendar-label': 'Otevřít kalendář',
  'project-fields.project-start-date.read-only':
    'Datum zahájení mohou změnit pouze přispěvatelé s přístupem k úpravám.',
  'project-fields.project-start-date.title': 'Datum zahájení',
  'project-fields.project-state.archived': 'Archivováno',
  'project-fields.project-state.at-risk': 'V ohrožení',
  'project-fields.project-state.cancelled': 'Zrušeno',
  'project-fields.project-state.completed': 'Dokončeno 🎉',
  'project-fields.project-state.off-track': 'Ve skluzu',
  'project-fields.project-state.on-track': 'Podle plánu',
  'project-fields.project-state.paused': 'Pozastaveno',
  'project-fields.project-state.pending': 'Čekající',
  'project-fields.project-status-picker.project-status-picker-more-button': 'Více stavů',
  'project-fields.project-status.title': 'Stav',
  'project-fields.project-tags.add-tags-title': 'Přidat štítky',
  'project-fields.project-tags.empty-title': 'Žádné štítky',
  'project-fields.project-tags.title': 'Štítky',
  'project-fields.project-target-date.picker-placeholder': 'Čekající',
  'project-fields.project-target-date.title': 'Cílové datum',
  'project-fields.project-work-items.show-all-non-final': 'Zobrazit vše',
  'project-fields.project-work-items.show-less-non-final': 'Zobrazit méně',
  'project-fields.project-work-tracked-picker.cancel-button': 'Uložit',
  'project-fields.project-work-tracked-picker.fallback-description':
    'Přidejte odkaz na místo, kde sledujete práci na tomto projektu.',
  'project-fields.project-work-tracked-picker.fallback-invalid-url': 'Zadejte platnou adresu URL.',
  'project-fields.project-work-tracked-picker.no-recently-viewed-header': 'Vyhledat požadavky Jira',
  'project-fields.project-work-tracked-picker.no-recently-viewed-result':
    'Vyhledejte nebo přidejte odkazy na umístění, kde sledujete práci na tomto projektu.',
  'project-fields.project-work-tracked-picker.no-search-result':
    'Zkuste znovu zadat klíč požadavku Jira / adresu URL nebo použít při vyhledávání jiné termíny.',
  'project-fields.project-work-tracked-picker.no-search-results-header': 'Nepodařilo se najít shodu.',
  'project-fields.project-work-tracked-picker.recently-viewed-title': 'Nedávno zobrazené',
  'project-fields.project-work-tracked-picker.results-title': 'Výsledky',
  'project-fields.project-work-tracked-picker.search-placeholder': 'Vyhledejte v Jira nebo přidejte odkaz.',
  'project-fields.project-work-tracked-picker.sync-form-description':
    'Propojte tento projekt s vybraným požadavkem Jira a automaticky synchronizujte podrobnosti.',
  'project-fields.project-work-tracked-picker.sync-form-warning':
    'Upozorňujeme, že každý, kdo vidí tento požadavek Jira, uvidí i podrobnosti vašeho projektu.',
  'project-fields.project-work-tracked-picker.sync-with-jira-button': 'Synchronizovat s Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-cancel-button': 'Zrušit',
  'project-fields.project-work-tracked-picker.sync-with-jira-connect-button': 'Připojit',
  'project-fields.project-work-tracked-picker.sync-with-jira-detail-selection':
    'Vyberte podrobnosti, které chcete v budoucnu použít pro tuto práci:',
  'project-fields.project-work-tracked-picker.sync-with-jira-header': 'Synchronizovat tento projekt s Jira',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing': 'Synchronizace štítků',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing-description':
    'Synchronizovat štítky z Jira se štítky z projektu',
  'project-fields.project-work-tracked-picker.sync-with-jira-project-name': 'Název projektu',
  'project-fields.project-work-tracked-picker.sync-with-jira-start-date': 'Datum zahájení',
  'project-fields.project-work-tracked-picker.sync-with-jira-target-date': 'Cílové datum',
  'project-fields.project-work-tracked-picker.sync-with-jira-via-project': '{projectName} {viaProject}',
  'project-fields.project-work-tracked-picker.text-placeholder': 'Odkaz ke sledování práce',
  'project-fields.project-work-tracked-picker.work-tracked-picker-content':
    'Vyhledejte požadavky Jira nebo přidejte odkazy na umístění, kde sledujete práci na tomto projektu.',
  'project-fields.project-work-tracked-picker.work-tracked-picker-title': 'Kde se práce sleduje?',
  'project-fields.project-work-tracked.add-work-tracked-title': 'Přidat požadavky Jira',
  'project-fields.project-work-tracked.empty-title': 'Žádné požadavky Jira',
  'project-fields.project-work-tracked.linked-with-jira-label': 'Propojeno s Jira',
  'project-fields.project-work-tracked.sync-now-label': 'Synchronizovat',
  'project-fields.project-work-tracked.synced-with-jira-label': 'Synchronizováno s Jira',
  'project-fields.project-work-tracked.title': 'Sledované požadavky',
  'project-fields.related-project-picker.add-button-label': 'Přidat',
  'project-fields.related-project-picker.cancel-button-label': 'Zrušit',
  'project-fields.related-project-picker.depended-by-option-label': 'Na projektu závisí:',
  'project-fields.related-project-picker.depends-on-option-label': 'Projekt závisí na:',
  'project-fields.related-project-picker.empty-state-description':
    'Najděte související projekty, které odkazují na tento projekt.',
  'project-fields.related-project-picker.empty-state-title': 'Vyhledat projekty',
  'project-fields.related-project-picker.project-relationship-type-label': 'Vyberte typ vztahu projektu',
  'project-fields.related-project-picker.project-search-placeholder': 'Vyhledat projekty',
  'project-fields.related-project-picker.related-option-label': 'Projekt souvisí s:',
  'project-fields.related-project-picker.related-project-list-label': 'Související projekty',
  'project-fields.related-projects.add-related-title': 'Přidat související projekty',
  'project-fields.related-projects.add-related-tooltip': 'Přidejte závislé nebo související projekty.',
  'project-fields.related-projects.dependent-by-projects-heading': 'Závisí na tom:',
  'project-fields.related-projects.dependent-on-projects-heading': 'Závisí na:',
  'project-fields.related-projects.empty-title': 'Žádné související projekty',
  'project-fields.related-projects.related-projects-heading': 'Souvisí s:',
  'project-fields.related-projects.title': 'Související',
  'project-fields.use-project-flags.generic-error-description': 'Něco se pokazilo. Zkuste to znovu za pár minut.',
  'project-fields.use-project-flags.generic-error-title': 'Něco se pokazilo',
  'project-fields.use-project-flags.project-links-add-failure-title': 'Přidání odkazu se nezdařilo',
  'project-fields.use-project-flags.project-links-delete-failure-title': 'Odebrání odkazu se nezdařilo',
  'project-fields.use-project-flags.project-links-edit-failure-title': 'Odkaz nelze upravit',
  'project-fields.use-project-flags.project-owner-change-error-header': 'Změna vlastníka projektu se nezdařila',
  'project-fields.use-project-flags.project-start-date-change-error-header':
    'Aktualizace data zahájení projektu se nezdařila',
  'project-fields.use-project-flags.project-tags-add-failure-title': 'Přidání štítku se nezdařilo',
  'project-fields.use-project-flags.project-tags-create-failure-title': 'Vytvoření štítku se nezdařilo',
  'project-fields.use-project-flags.project-tags-create-limit-failure-description':
    'Název štítku, který jste zadali, je příliš dlouhý. Zadejte název štítku s 255 znaky nebo méně.',
  'project-fields.use-project-flags.project-tags-create-limit-failure-title': 'Vytvoření štítku se nezdařilo',
  'project-fields.use-project-flags.project-tags-remove-failure-title': 'Odebrání štítku se nezdařilo',
  'project-fields.use-project-flags.project-team-remove-failure-description':
    'Při odebírání týmu došlo k chybě. Zkuste to znovu.',
  'project-fields.use-project-flags.related-project-remove-failure-title':
    'Odebrání souvisejícího projektu se nezdařilo',
};
